<template>
  <div class="left flex fd">
    <div
      class="menulist flex ac"
      v-for="(i, j) in menu"
      @mouseover="menuover(j)"
      @mouseleave="menuleave(j)"
      @click="menuclick(j)"
      :style="{
        backgroundImage:
          i.status == 1
            ? 'url(' + require('../../assets/image/menu1.png') + ')'
            : i.status == 2
            ? 'url(' + require('../../assets/image/menu3.png') + ')'
            : 'url(' + require('../../assets/image/menu2.png') + ')',
        width: i.status == 2 ? '11.93vw' : '10.89vw',
      }"
      :key="j"
      style="cursor: pointer;"
    >
      <img :src="i.status == 1 ? i.icon : i.checkicon" alt style="margin-left: 10%;" />
      <div>
        <p style="font-size: 0.83vw; color: white">{{ i.zh }}</p>
        <p style="font-size: 0.52vw; color: white">{{ i.eng }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menu: [
        {
          zh: "首页",
          eng: "Index",
          status: "1",
          path: "/index",
          icon: require("../../assets/image/menuicon/icon／工程信息@2x.png"),
          checkicon: require("../../assets/image/menuicon/icon／工程信息-选中@2x.png")
        },
        {
          zh: "工程态势",
          eng: "Engineering informat",
          status: "1",
          path: "/situation",
          icon: require("../../assets/image/menuicon/icon／工程态势@2x.png"),
          checkicon: require("../../assets/image/menuicon/icon／工程态势-选中@2x.png")
        },
        {
          zh: "设备监控",
          eng: "Equipment Monitoring",
          status: "1",
          path: "/equipment",
          icon: require("../../assets/image/menuicon/icon／设备监控@2x.png"),
          checkicon: require("../../assets/image/menuicon/icon／设备监控-选中@2x.png")
        },
        {
          zh: "人员监控",
          eng: "Personnel monitoring",
          status: "1",
          path: "/staff",
          icon: require("../../assets/image/menuicon/icon／人员监控@2x.png"),
          checkicon: require("../../assets/image/menuicon/icon／人员监控-选中@2x.png")
        },

        {
          zh: "视频监控",
          eng: "Engineering situation",
          status: "1",
          path: "/video",
          icon: require("../../assets/image/menuicon/icon／视频监控@2x.png"),
          checkicon: require("../../assets/image/menuicon/icon／视频监控-选中@2x.png")
        },
        {
          zh: "材料监控",
          eng: "Material Monitoring",
          status: "1",
          path: "/metrial",
          icon: require("../../assets/image/menuicon/icon／材料监控@2x.png"),
          checkicon: require("../../assets/image/menuicon/icon／材料监控-选中@2x.png")
        },
        // {
        //   zh: "工法指导",
        //   eng: "Method Guidance",
        //   status: "1",
        //   path: "",
        //   disable: true,
        //   icon: "",
        //   checkicon: "",
        //   icon: require("../../assets/image/menuicon/icon／工法指导.png"),
        // },
        {
          zh: "环境监控",
          eng: "Environmental Monitoring",
          status: "1",
          path: "/environment",
          icon: require("../../assets/image/menuicon/icon／环境监控@2x.png"),
          checkicon: require("../../assets/image/menuicon/icon／环境监控-选中@2x.png")
        }
      ]
    };
  },
  created() {
    this.menushow();
  },
  methods: {
    menuclick(e) {
      for (let i in this.menu) {
        if (e == i) {
          this.menu[i].status = 3;
          this.$router.push({
            path: this.menu[i].path
          });
        } else {
          this.menu[i].status = 1;
        }
      }
    },
    menuleave(e) {
      for (let i in this.menu) {
        if (this.menu[i].status == 2) {
          this.menu[i].status = 1;
        }
      }
    },
    menuover(e) {
      for (let i in this.menu) {
        if (e == i) {
          if (this.menu[i].status == 3) {
            return;
          } else {
            this.menu[i].status = 2;
          }
        }
      }
    },
    menushow() {
      let path = this.$route.path;
      for (let i in this.menu) {
        if (path == this.menu[i].path) {
          this.menu[i].status = 3;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.left {
  .menulist {
    img {
      width: 1.56vw;
    }
    width: 100%;
    height: 3.28vw;
    gap: 0.63vw;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: 0 0;
    padding-bottom: 0.36vw;
  }
  width: 10.89vw;
  height: 27.08vw;
  top: 11.15vw;
  left: 0;
  gap: 0.36vw;
  z-index: 999;
  position: fixed;
}
</style>
